module.exports = __webpack_public_path__ + "static/media/onboarding-get-started.a365eae9.png";